import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import css from './download-picker.scss';
import { downloadPickerTranslation } from './download-picker-translation';

import { updateReportFormat } from '../format-picker/format-picker-actions';
import {
    updateReportSelection,
    resetReportSelections
} from './download-report-actions';

import {
    ACTIVITY_MASTERY,
    PARTICIPATION,
    SKILL_QUESTS_MASTERY
} from '../../report-filters/filter-constants';

/**
 * DOWNLOAD PICKER
 * ----------------------------
 * Modal content on bulk classroom export click
 * @param reportTypes: Currently selected report types array
 * @param updateReportFormat: Action to manage report formats
 */
class DownloadPicker extends Component {
    static propTypes = {
        reportTypes: PropTypes.array,
        updateReportSelection: PropTypes.func.isRequired,
        resetReportSelections: PropTypes.func
    };

    componentWillUnmount() {
        this.props.resetReportSelections();
    }

    isInputSelected = (type) => this.props.reportTypes.includes(type);

    renderCheckbox = (reportType) => {
        const key = `Download Picker - ${reportType}`;

        return (
            <div className={css.selection}>
                <input
                    id={reportType}
                    name={reportType}
                    type="checkbox"
                    checked={this.isInputSelected(reportType)}
                    onChange={() =>
                        this.props.updateReportSelection(reportType)
                    }
                />
                <label htmlFor={reportType}>{window.i18n._(key)}</label>
            </div>
        );
    };

    render() {
        const {
            headerSelectText,
            headerWarningText,
            reportTypeHeaderText,
            reportFormatFooterText
        } = downloadPickerTranslation();

        return (
            <div className={css['download-modal-content']}>
                <div>
                    <p>{headerSelectText}</p>
                    <p>{headerWarningText}</p>
                </div>
                <div className={css['report-type']}>
                    <span className={css.header}>{reportTypeHeaderText}</span>
                    <div className={css['selection-group']}>
                        {this.renderCheckbox(PARTICIPATION)}
                        {this.renderCheckbox(ACTIVITY_MASTERY)}
                        {this.renderCheckbox(SKILL_QUESTS_MASTERY)}
                    </div>
                </div>
                <div className={css.footer}>{reportFormatFooterText}</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    reportFormats: state.formatReport.reportFormats,
    reportTypes: state.downloadReport.reportTypes
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            updateReportSelection,
            updateReportFormat,
            resetReportSelections
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(styleable(css)(DownloadPicker));



// WEBPACK FOOTER //
// ./components/sub-heading/download-report/download-picker.js